import React from 'react';
import Select from 'react-select';

const SelectBox = ({ name, label, value, getOptionLabel, getOptionValue, error, options, onChange, styles, col, isMulti }) => {
   const customStyles = {
      menu: (styles) => ({
         ...styles,
         zIndex: 10,
         border: 0,
      }),
      control: (base) => ({
         ...base,
         height: 30,
         minHeight: 30,
      }),
   };
   const multiple = isMulti;
   if (multiple) {
      return (
         <>
            <Select
               styles={customStyles}
               name={name}
               value={value}
               isMulti
               getOptionLabel={getOptionLabel}
               getOptionValue={getOptionValue}
               options={options}
               onChange={onChange}
               isClearable={true}
               isSearchable={true}
               theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                     ...theme.colors,
                     primary25: 'primary50',
                     primary: '#283a66',
                  },
               })}
            />
            {error && (
               <div class='alert alert-danger' role='alert'>
                  {error}
               </div>
            )}
         </>
      );
   } else {
      return (
         <>
            <Select
               styles={customStyles}
               name={name}
               value={value}
               getOptionLabel={getOptionLabel}
               getOptionValue={getOptionValue}
               options={options}
               onChange={onChange}
               theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                     ...theme.colors,
                     primary25: 'primary50',
                     primary: 'black',
                  },
               })}
            />
            {error && (
               <div class='alert alert-danger' role='alert'>
                  {error}
               </div>
            )}
         </>
      );
   }
};

export default SelectBox;
